export default __webpack_public_path__ + "static/media/expert-ribbon.ce1d7a6f.svg";